@if (showLocation() && !isOfflineCache() && locationService.googleScriptLoaded) {
  <!--
    axe flags "Certain ARIA roles must contain particular children" on .gm-style-mtc-bbw
    (role="menubar" wrapping role="presentation" children) - the Map/Satellite control
    rendered internally by the Google Maps JavaScript SDK. Not markup this template
    emits or can correct; documented as a known SDK issue under CL-29360.

    axe also flags "ARIA hidden element must not be focusable" on an internal, invisible
    (opacity: 0) helper <iframe aria-hidden="true" tabindex="0"> the SDK inserts for its
    own use. Same situation - SDK-generated markup with no exposed map option to control
    it, documented as a known SDK issue rather than patched here.
  -->
  <google-map
    class="h-full w-full"
    height="{{ offsetHeight() }}"
    width="100%"
    [options]="{ fullscreenControl: true, mapId: googleMapId() }"
    [center]="{ lat: latitude(), lng: longitude() }"
    [zoom]="15"
  >
    <map-advanced-marker #marker [position]="{ lat: latitude(), lng: longitude() }"></map-advanced-marker>
  </google-map>
}
@if (!showLocation() && !isOfflineCache()) {
  <button
    type="button"
    class="button-remove-style w-full flex cursor-pointer relative"
    (click)="showLocationMessage()"
    [ngStyle]="{ height: offsetHeight() }"
  >
    <i class="mi2-map-grid w-full h-full flex items-center justify-center text-[64px] rounded-[3px]"></i>
    <div
      class="bg-white opacity-80 dark:bg-black text-color text-xs w-full h-full absolute rounded-[3px] flex flex-col justify-center items-center font-bold mb-[5.25px]"
    ></div>
    <div
      class="text-color text-xs w-full h-full absolute rounded-[3px] flex flex-col justify-center items-center font-bold mb-[5.25px]"
    >
      <div
        class="w-[37.625px] h-[37.625px] rounded-[18.8125px] shadow-[0_0_3.5px_0_rgba(0,0,0,0.2)] bg-white flex items-center justify-center"
      >
        <i class="mi2-location-pin text-lg text-red-500"></i>
      </div>
      {{ 'cl_chat.clickToShowLocation' | translate | uppercase }}
    </div>
  </button>
}
@if (chatMessage()) {
  <div
    [attr.aria-label]="'cl_chat.sharedALocation' | translate"
    class="text-color rounded-b-2xl text-sm font-semibold px-[14.5px] py-4 bg-surface-100 dark:bg-surface-600"
    [ngClass]="{ '!bg-gradient-to-r from-[#0073d0] to-[#005ca6] !text-[var(--p-surface-0)]': isMine() }"
  >
    {{ 'cl_chat.sharedALocation' | translate }}
  </div>
}
